import React from "react";
import { ConnectWithLineTaskView as CoreView } from "@jelly/lesson";

import defaultStyle from "./ConnectWithLineTaskView.module.scss";

export const ConnectWithLineTaskView: React.FC<React.ComponentProps<typeof CoreView>> = (props) => {
  return <CoreView {...props} style={defaultStyle} />;
};
